module.exports = __webpack_public_path__ + "onboarding-steps.c00ee331a6ae184027c9acbdc1c562c7.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/components/DeploymentProcess/onboarding-steps.svg
// module id = 1792
// module chunks = 8